import { render } from "./smollBasket.vue?vue&type=template&id=16e7735d&scoped=true"
import script from "./smollBasket.vue?vue&type=script&lang=js"
export * from "./smollBasket.vue?vue&type=script&lang=js"

import "./smollBasket.vue?vue&type=style&index=0&id=16e7735d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e7735d"]])

export default __exports__